import { render, staticRenderFns } from "./bnvselect.vue?vue&type=template&id=5fd79c83&"
import script from "./bnvselect.vue?vue&type=script&lang=js&"
export * from "./bnvselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports